import { createAction } from 'deox';
export const resetInstantCredit = createAction('RESET_INSTANT_CREDIT');
